const LOGO_URL = "https://customer-assets.emergentagent.com/job_trusted-labs-3/artifacts/cxkdhap3_IMG-20260509-WA0162.jpg";

export default function Logo({ variant = "dark", size = "md" }) {
  const sizes = {
    sm: "h-10",
    md: "h-14",
    lg: "h-24",
  };
  const isLight = variant === "light";

  return (
    <div className="flex items-center" data-testid="brand-logo">
      <div
        className={`${
          isLight ? "bg-white" : "bg-transparent"
        } ${isLight ? "px-2 py-1" : ""} flex items-center`}
      >
        <img
          src={LOGO_URL}
          alt="Güven Kimya"
          className={`${sizes[size] || sizes.md} w-auto object-contain`}
          loading="eager"
        />
      </div>
    </div>
  );
}
